import * as React from "react";
import { Link } from "gatsby";

import logo from "../img/logo.svg";
import facebook from "../img/social/facebook.svg";
import instagram from "../img/social/instagram.svg";
import twitter from "../img/social/twitter.svg";
import vimeo from "../img/social/vimeo.svg";
import vk from "../img/social/vk.svg";

const Footer = class extends React.Component {
  render() {
    return (
      <footer className="footer has-background-black has-text-white-ter">
        <div className="content has-text-centered has-background-black has-text-white-ter">
          <div className="container has-background-black has-text-white-ter">
            <div style={{ maxWidth: "100vw" }} className="columns">
              <div className="column is-4">
                <section className="menu">
                  <ul className="menu-list">
                    <li>
                      <Link className="navbar-item" to="/blog">
                        Хранилище заметок
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="https://vk.com/datasay" target="_blank">
                        datasay в VK ➜
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="https://vk.com/notetaking" target="_blank">
                        Про аутлайнеры в VK ➜
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="https://web.archive.org/web/20250212112107/https://remnote.pubpub.org/" target="_blank">
                        WiKi по RemNote (архив) ➜
                      </Link>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column is-4">
                <section>
                  <ul className="menu-list">
                    <li>
                      <Link to="/" className="navbar-item">
                        Главная страница
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/brief">
                        Об авторе
                      </Link>
                    </li>
                    <li>
                      <Link className="navbar-item" to="/work-formats">
                        Форматы сотрудничества
                      </Link>
                    </li>
                  </ul>
                </section>
              </div>
              <div className="column is-4 social">
                <a title="vimeo" href="https://vk.com/datasay">
                  <img
                    src={vimeo}
                    alt="vimeo"
                    style={{ width: "1em", height: "1em" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
};

export default Footer;
